var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "core-data-statistics" },
    [
      _c("div", { staticClass: "title" }, [_vm._v("核心数据统计")]),
      _vm._v(" "),
      _c("div", { staticClass: "filter-bar" }, [
        _c("div", { staticClass: "filter-left" }, [
          _c(
            "div",
            { staticClass: "time-buttons" },
            [
              _vm._l(_vm.timeRangeOptions, function (item) {
                return _c(
                  "div",
                  {
                    key: item.value,
                    staticClass: "time-btn pointer",
                    class: { active: _vm.queryParams.timeRange === item.value },
                    on: {
                      click: function ($event) {
                        return _vm.onTimeRangeChange(item.value)
                      },
                    },
                  },
                  [_vm._v("\n          " + _vm._s(item.label) + "\n        ")]
                )
              }),
              _vm._v(" "),
              _vm.queryParams.timeRange === 6
                ? _c(
                    "div",
                    { staticClass: "date-picker-wrap" },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          align: "right",
                          "unlink-panels": "",
                          "range-separator": "至",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          "value-format": "yyyy-MM-dd",
                        },
                        on: { change: _vm.onDateRangeChange },
                        model: {
                          value: _vm.dateRange,
                          callback: function ($$v) {
                            _vm.dateRange = $$v
                          },
                          expression: "dateRange",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onQuery } },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { plain: "" }, on: { click: _vm.onReset } },
                [_vm._v("重置")]
              ),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "filter-right" }, [
          _c(
            "button",
            { staticClass: "export-btn", on: { click: _vm.openExportDialog } },
            [
              _c("img", { attrs: { src: require("@/assets/ExportIcon.png") } }),
              _vm._v(" "),
              _c("span", [_vm._v("导出")]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-wrap" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                border: "",
                "header-cell-style": { "text-align": "center" },
                "cell-style": { "text-align": "center" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "statsDate", label: "日期", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "registeredCount",
                  label: "新增会员数",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderCountTotal",
                  label: "总订单数",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderCount",
                  label: "有效订单数",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderAmountTotal",
                  label: "总订单金额(元)",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderAmount",
                  label: "有效订单金额(元)",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "incomeTotal",
                  label: "总订单佣金(元)",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "income",
                  label: "有效订单佣金(元)",
                  align: "center",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-wrap" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.queryParams.page,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.queryParams.size,
              layout: "total, prev, pager, next, sizes, jumper",
              total: _vm.total,
              background: "",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "数据导出管理",
            visible: _vm.exportDialogVisible,
            width: "1000px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.exportDialogVisible = $event
            },
            close: _vm.onExportDialogClose,
          },
        },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.onExportTabClick },
              model: {
                value: _vm.activeExportTab,
                callback: function ($$v) {
                  _vm.activeExportTab = $$v
                },
                expression: "activeExportTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "数据导出", name: "export" } },
                [
                  _c(
                    "div",
                    { staticClass: "export-tab-content" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "exportForm",
                          attrs: {
                            model: _vm.exportForm,
                            rules: _vm.exportRules,
                            "label-width": "100px",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "文件名：", prop: "fileName" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入文件名" },
                                model: {
                                  value: _vm.exportForm.fileName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.exportForm, "fileName", $$v)
                                  },
                                  expression: "exportForm.fileName",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "导出格式：", prop: "fileType" },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.exportForm.fileType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.exportForm, "fileType", $$v)
                                    },
                                    expression: "exportForm.fileType",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 0 } }, [
                                    _vm._v("xlsx格式"),
                                  ]),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("csv格式"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "export-tip" }, [
                        _vm._v("注：24小时内，数据导出次数限制在5次"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "export-actions" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.onConfirmExport },
                            },
                            [_vm._v("确认")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { plain: "" },
                              on: { click: _vm.onResetExport },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "数据导出记录", name: "record" } },
                [
                  _c(
                    "div",
                    { staticClass: "record-tab-content" },
                    [
                      _c(
                        "div",
                        { staticClass: "record-filter" },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              placeholder: "输入文件名查询",
                              clearable: "",
                            },
                            model: {
                              value: _vm.recordQueryParams.fileName,
                              callback: function ($$v) {
                                _vm.$set(_vm.recordQueryParams, "fileName", $$v)
                              },
                              expression: "recordQueryParams.fileName",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "120px",
                                "margin-left": "10px",
                              },
                              attrs: { placeholder: "状态", clearable: "" },
                              model: {
                                value: _vm.recordQueryParams.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.recordQueryParams, "status", $$v)
                                },
                                expression: "recordQueryParams.status",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "处理中", value: 0 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "已完成", value: 1 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "失败", value: 2 },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "10px" },
                              attrs: { type: "primary" },
                              on: { click: _vm.onQueryRecord },
                            },
                            [_vm._v("查询")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { plain: "" },
                              on: { click: _vm.onResetRecord },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.recordLoading,
                              expression: "recordLoading",
                            },
                          ],
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.recordTableData,
                            border: "",
                            "header-cell-style": { "text-align": "center" },
                            "cell-style": { "text-align": "center" },
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "fileName",
                              label: "文件名",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "处理进度", align: "center" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.status === 0
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "warning" } },
                                          [_vm._v("处理中")]
                                        )
                                      : scope.row.status === 1
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "success" } },
                                          [_vm._v("已完成")]
                                        )
                                      : scope.row.status === 2
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "danger" } },
                                          [_vm._v("失败")]
                                        )
                                      : _c("span", [_vm._v("-")]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "fileSizeText",
                              label: "文件大小",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "finishTime",
                              label: "处理结束时间",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "操作", align: "center" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.status === 1
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              size: "mini",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onDownloadRecord(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("下载")]
                                        )
                                      : _c("span", [_vm._v("-")]),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "pagination-wrap mt20" },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.recordQueryParams.page,
                              "page-sizes": [10, 20, 50, 100],
                              "page-size": _vm.recordQueryParams.size,
                              layout: "total, prev, pager, next, sizes, jumper",
                              total: _vm.recordTotal,
                              background: "",
                            },
                            on: {
                              "size-change": _vm.handleRecordSizeChange,
                              "current-change": _vm.handleRecordCurrentChange,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }